'use strict';

import GoogleMap from './lib/GoogleMap';

document.addEventListener('DOMContentLoaded', () => {
  const gMap = new GoogleMap();

  const location = document.getElementById('address').innerText;
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode(
    {
      address: location,
      region: 'jp',
    },
    (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        gMap.add('.gmap', {
          latLng: {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
          },
        });
        gMap.init();
      }
    },
  );
});
